import request from '@/utils/request';
import { getToken } from '@/utils/auth';

export function login(data) {
  const formData = new FormData();
  for (const key in data) {
    formData.append(key, data[key]);
  }
  return request({
    url: '/token/login/',
    method: 'post',
    data: data,
    headers: { 'Content-Type': 'application/json' }
  });
}

export function getInfo() {
  const token = getToken();

  if (token) {
    return request({
      url: '/users/me/',
      method: 'get',
    });
  }
}

export function logout() {
  return request({
    url: '/token/logout/',
    method: 'post',
  });
}

export function changePassword(data) {
  return request({
    url: '/users/set_password/',
    method: 'post',
    data: data,
    headers: { 'Content-Type': 'application/json' }
  });
}

export function csrf() {
  return request({
    url: '/sanctum/csrf-cookie',
    method: 'get',
  });
}

export function updateUser(data) {
  return request({
    url: '/users/me/',
    method: 'patch',
    data: data,
    headers: { 'Content-Type': 'application/json' }
  });
}
